import actionTypes from "../../action-types";

const initialState = {
  reports: {
    chartMultisite: {
      series: [],
      categories: new Set(),
    },
    sparkLineSum: {
      data: [],
      labels: [],
    },
    sparkLineImps: {
      data: [],
      labels: [],
    },
    sparkLineCpm: {
      data: [],
      labels: [],
    },
    total: 0,
    totalCpm: 0,
    totalImps: 0,
    totalSumWithBonus: 0,
    yesterday: {
      cpm: 0,
      sum: 0,
      impressions: 0,
    },
  },
  isLoading: true,
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.DASH_REPORT:
      return {
        ...state,
        reports: payload,
      };
    case actionTypes.REPORTS_LOADING:
      return {
        ...state,
        isLoading: payload,
      };
    default:
      return {
        ...state,
      };
  }
};
export default reducer;
